import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export const TIMELINE_MODAL_PANEL_ID = 'timeline-panel';

export const openTimelineModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.TIMELINE_MODAL,
      panelProps: {
        panelId: TIMELINE_MODAL_PANEL_ID,
      },
    })
  );
};
